import { render, staticRenderFns } from "./page-music-category.vue?vue&type=template&id=57ca329e&"
import script from "./page-music-category.vue?vue&type=script&lang=ts&"
export * from "./page-music-category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports